import { object } from "yup";

import { templateAssetValidationSchema } from "@dzambalaorg/mui-inputs-asset";

export const craftFormValidationSchema = object().shape({
  item: templateAssetValidationSchema,
  price: templateAssetValidationSchema,
});
